import "../Banner/Banner.css"

function Banner () {
  return (
    
    <div className="BGI"></div>
    
  )
}
export default Banner;